/**
 * @file
 * Example of a custom script file.
 */

((Drupal) => {
  Drupal.behaviors.GDSSubthemeGlobal = {
    attach: (context, settings) => {
      // Custom JS code to be placed here
      // Adding exit event to exit proceed button.
            jQuery(document).on("dialogopen", "div[aria-describedby='modal_external_link']", function(event, ui) {
    		var extLink = jQuery('#modal_external_link .gds-modal__body .external-confirm').attr('data-destination');
		setTimeout(function() {
        	  jQuery('div[aria-describedby="modal_external_link"] .external-confirm').attr('data-it-exit-link', extLink);
		  jQuery('div[aria-describedby="modal_external_link"] .external-confirm').removeAttr('data-it-button');
                  jQuery('div[aria-describedby="modal_external_link"] .gds-link--menu.dialog-cancel').attr('data-it-button', 'Close');
                  jQuery('div[aria-describedby="modal_external_link"] button#close-button').attr('data-it-button', 'Close');
                 }, 500);
	    });
	 setTimeout(function () {
	 if(jQuery("a[title='English']").length > 0) {
                var en_url = jQuery("head link[hreflang='en-CA']").attr('href');
                jQuery("a[title='English']").attr('href', en_url);
         }
         if(jQuery("a[title='Français']").length > 0 ) {
                var fr_url = jQuery('head link[hreflang="fr-CA"]').attr('href');;
                jQuery("a[title='Français']").attr('href', fr_url);
         }
	 }, 250);

	 jQuery('input[type="submit"], button, a, input[type="button"]').each(function () {
             var attrName = (this.getAttribute('aria-label') === null) ? this.getAttribute('title') : this.getAttribute('aria-label');
             if (attrName === null)
                 attrName = this.getAttribute('value');
             if (attrName === "Twitter" || attrName === "YouTube" || attrName === "Instagram"){
                 this.setAttribute('data-it-button', 'social: '+attrName);
             }
             if (attrName == 'Learn more' || attrName == 'Pour en savoir plus' || attrName == 'Commencer') {
                 var text = jQuery(this).closest('article.gds-card , .gds-highlight-banner').find('.gds-heading').text().trim();
                 if (text != '') {
                     this.setAttribute('data-it-button', attrName+ ' : ' + text);
                 }
             }else{
                 this.setAttribute('data-it-button', attrName);
             }
          });
         setTimeout(function () {
            // for PDF common AA
	     jQuery('a[href*="bipdf"],a[href$="txt"],a[href*="pdf"],a[href$="xlsm"],a[href$="pptx"]').each(function () {
	 	 var asset_url = jQuery(this).attr("href").split('/').pop();
	 	 var asset_name = asset_url.replace(/-/g, ' ');
	 	 jQuery(this).attr('data-it-asset', asset_name);
		 jQuery(this).removeAttr('data-it-button');
	     }); 
          }, 200);
	  jQuery(".gds-btn").each(function () {
             var attrName = (this.getAttribute('data-it-button') === null) ? this.getAttribute('title') : this.getAttribute('data-it-button');
             if (attrName !== null) {
		jQuery(this).removeAttr('data-it-button');
                this.setAttribute('data-it-asset', attrName);
             }
          });
	  // Accessibility fixes
	  jQuery('a.main-link.gds-link--menu').attr('aria-label', 'Select a Language')
	  jQuery('a.gds-link.dialog-cancel').attr('role', 'button');
	  jQuery('.gds-footer__logo img').attr('title', 'Boehringer Ingelheim');
	  jQuery("a").each(function () {
	  	jQuery(this).attr("rel", "noopener");
	  });
	  jQuery('img').each(function () {
	    const alt = jQuery(this).attr('alt');
	    if (alt === undefined || alt.trim() === '') {
	      jQuery(this).attr('role', 'presentation');
	    }
	  });
	  // footer active link
	  jQuery('.gds-footer .gds-inline-menu__item .gds-link.gds-link--link-intercept.gds-link--menu').each(function(){
	    var path_url_name = window.location.pathname;
	    var path_url = jQuery(this).attr('href');
	    if( path_url_name === path_url ){
	      jQuery(this).parent().addClass('gds-inline-menu__item--active');
	    }
	 });
	
	/* Accessibility JS */
	jQuery('.gds-key-fact img').attr('alt', '');
	jQuery('.gds-metanav__menu ul').attr('role', 'button');
	jQuery('.gds-metanav__menu ul li').attr('role', 'presentation');
	jQuery('a.gds-logo').attr({
	   'title': 'Boehringer Ingelheim',
	   'aria-label': 'Boehringer Ingelheim'
	});
	jQuery('[lang="FR-CA"]').each(function () {jQuery(this).attr('lang', 'fr');});
	jQuery('[lang="en-CA"]').each(function () {jQuery(this).attr('lang', 'en');});
	jQuery('.gds-dropdown-menu ul').attr('role', 'button');
	jQuery('.gds-dropdown-menu ul li').attr('role', 'presentation');

	//end
    },
  };
})(Drupal);
